module.exports = __webpack_public_path__ + "static/img/sfz.e5f391b8.png";